module.exports = __webpack_public_path__ + "static/media/add-user.6ad2981c.svg";